import { AgColDefsI, AgGridI } from "../../../../shared/common-components/ag-grid/ag-grid.model";
import { DateCellRendererComponent } from "../../../../shared/common-components/ag-grid/date-cell-renderer/date-cell-renderer.component";
import { NumericCellRendererComponent } from "../../../../shared/common-components/ag-grid/numeric-cell-renderer/numeric-cell-renderer.component";
import { StatusCellRendererComponent } from "../../../../shared/common-components/ag-grid/status-cell-renderer/status-cell-renderer.component";
import { TextRendererComponent } from "../../../../shared/common-components/ag-grid/text-renderer/text-renderer.component";
import { AmountColWidth, StorageName } from "../../../../shared/enum/common-enum";
import { API_URL_GET_ALL_LAYAWAYSREPORT } from "../../../../shared/url-helper/url-helper";

export class LayawaysReport {
}

const NameColumn: AgColDefsI = {
    headerName: "Name",
    field: "name",
    minWidth: AmountColWidth.MinWidth,
    resizable: true,
    headerClass: "custom-column-group-cell px-0",
    cellClass: "custom-column-group-cell px-0",
    editable: false,
    sortable: true,
    cellRenderer: TextRendererComponent,
};
const InvoiceNoColumn: AgColDefsI = {
    headerName: "Invoice No.",
    field: "againstInvoiceNo",
    minWidth: AmountColWidth.MinWidth,
    resizable: true,
    headerClass: "custom-column-group-cell px-0",
    cellClass: "custom-column-group-cell px-0 text-primary",
    editable: false,
    sortable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },

};
const InstallmentFundNoColumn: AgColDefsI = {
    headerName: "Installment Fund No.",
    field: "invoiceNo",
    minWidth: AmountColWidth.MinWidth,
    resizable: true,
    headerClass: "custom-column-group-cell px-0",
    cellClass: "custom-column-group-cell px-0 text-primary",
    editable: false,
    sortable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },

};
export const StatusColumn: AgColDefsI = {
    headerName: "Status",
    field: "status",
    headerClass: "px-0  ag_header_center  custom-column-group-cell",
    sortable: true,
    cellClass: "custom-column-group-cell d-flex align-items-center justify-content-center",
    minWidth: 180,
    maxWidth: 180,
    lockPinned: true,
    lockPosition: "right",
    editable: false,
    cellRenderer: StatusCellRendererComponent, 
};

const PickupDateColumn: AgColDefsI = {
    headerName: "Pickup Date",
    field: "pickupDate",
    resizable: true,
    sortable: true,
    minWidth: 80,
    editable: false,
    headerClass: "px-1 ag_header_end custom-column-group-cell",
    headerCheckboxSelection: false,
    cellRenderer: DateCellRendererComponent,
    cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};

const NextPaymentColumn: AgColDefsI = {
    headerName: "Next Payment",
    field: "nextPayment",
    resizable: true,
    sortable: true,
    minWidth: 80,
    editable: false,
    headerClass: "px-1 ag_header_end custom-column-group-cell",
    headerCheckboxSelection: false,
    cellRenderer: DateCellRendererComponent,
    cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};

const CreatedColumn: AgColDefsI = {
    headerName: "Created",
    field: "created",
    resizable: true,
    sortable: true,
    minWidth: 80,
    editable: false,
    headerClass: "px-1 ag_header_end custom-column-group-cell",
    headerCheckboxSelection: false,
    cellRenderer: DateCellRendererComponent,
    cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};
const AmountCollectedColumn: AgColDefsI = {
    headerName: "Amt. Collected",
    field: "amtCollected",
    minWidth: AmountColWidth.MinWidth,
    maxWidth: AmountColWidth.MaxWidth,
    headerClass: "custom-column-group-cell px-0 ag_header_end ",
    cellClass: "custom-column-group-cell px-0 text-end",
    editable: false,
    sortable: true,
    resizable: true,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: { isAmt: true },
}
const RemainingBalanceColumn: AgColDefsI = {
    headerName: "Remaining Bal.",
    field: "remainingBal",
    minWidth: AmountColWidth.MinWidth,
    maxWidth: AmountColWidth.MaxWidth,
    headerClass: "custom-column-group-cell px-0 ag_header_end ",
    cellClass: "custom-column-group-cell px-0 text-end",
    editable: false,
    sortable: true,
    resizable: true,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: { isAmt: true },
}

export const ColDefsLayawaysReport: AgColDefsI[] = [
    NameColumn,
    InstallmentFundNoColumn,
    InvoiceNoColumn,
    StatusColumn,
    CreatedColumn,
    NextPaymentColumn,
    PickupDateColumn,
    AmountCollectedColumn,
    RemainingBalanceColumn,

];

export const AgGridDataModelLayawaysReport: AgGridI = {
    colDefs: ColDefsLayawaysReport,
    rowSelection: "multiple",
    storageName: StorageName.TRANSACTION_LAYAWAYSREPORT_GRID,
    filterStorageName: StorageName.FILTER_TRANSACTION_LAYAWAYSREPORT_GRID,
    paginationStorageName: StorageName.PAGINATION_TRANSACTION_LAYAWAYSREPORT_GRID,
    sortStorageName: StorageName.SORT_TRANSACTION_LAYAWAYSREPORT_GRID,
    rows: [],
    rowHeight: 28,
    isFilter: true,
    isServerSidepagination: true,
    apiUrl: API_URL_GET_ALL_LAYAWAYSREPORT,
    showPagination: true,
};